import { Box, Button, Divider, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

import { StyledModal } from "../StyledModal";

const useStyles = makeStyles(() => ({
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    borderTop: `1px solid ${theme.palette.semantic["border/strong"]}`,
    alignItems: "center",
    height: 60,
  },
  linkUpdate: {
    textDecoration: "none",
    cursor: "pointer",
    width: "100%",
    height: "100%",
    color: theme.palette.primary.main,
  },
  linkLater: {
    textDecoration: "none",
    cursor: "pointer",
    width: "100%",
    height: "100%",
    color: theme.palette.text.secondary,
  },
  messageContent: {
    padding: "24px 24px 0 24px",
    zIndex: 1300,
  },
  description: {
    textAlign: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    zIndex: 1300,
  },
  divider: {
    height: "100%",
    backgroundColor: theme.palette.divider,
  },
}));

interface ContractExtendModalProps {
  onClose: () => void;
  onClickUpdate: () => void;
}

export const ContractExtendModal: React.FC<ContractExtendModalProps> = ({ onClose, onClickUpdate }) => {
  const classes = useStyles();

  return (
    <StyledModal onClickOutside={onClose}>
      <Box className={classes.messageContent}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h3">賃貸契約期間終了のご案内</Typography>
        </Box>
        <Typography className={classes.description}>
          設定された賃貸契約期間が終了したため、
          <br />
          本日から契約を締結した場合の収支に
          <br />
          表示が切り替わりました。
          <br />
          新たに契約を行った場合は、
          <br />
          賃貸契約情報を更新してください。
        </Typography>
      </Box>

      <Box className={classes.buttonContainer}>
        <Button className={classes.linkUpdate} onClick={onClickUpdate}>
          更新する
        </Button>
        <Divider orientation="vertical" flexItem className={classes.divider} />
        <Button className={classes.linkLater} onClick={onClose}>
          また後で
        </Button>
      </Box>
    </StyledModal>
  );
};
